







































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class AgreeTick extends Vue {
    @Prop({ default: false, type: Boolean }) readonly agree!: boolean
    @Prop({ default: 24 }) readonly size!: number
    @Prop({ default: '#B2B2B2' }) readonly disAgreeColor!: string
    @Prop({ default: '#2772D8' }) readonly agreeColor!: string
}
